module.exports = __webpack_public_path__ + "static/media/IMG_3617.53e434bb.jpg";